/* global process */

const config = {
  url: process.env.API_URL,
  wsUrl: process.env.WS_URL,
  version: process.env.VERSION,
  buildVersion: process.env.BUILD_VERSION,
  reportApiUrl: process.env.REPORTS_API_URL,
  squireSupplyUrl: 'https://supply.getsquire.com',
  phoneAgentUrl: process.env.VIDA_IFRAME_URL,
  phoneAgentAuthUrl: process.env.API_URL,
  stripeKey: process.env.SQUIRE_STRIPE_KEY,
  dayOfWeek: 'ddd',
  fullDayOfWeek: 'dddd',
  dateFormatISO: 'YYYY-MM-DD',
  dateFormat: 'MM/DD/YYYY',
  dateFormatRFC2822: 'ddd MMM DD YYYY',
  fullDateFormat: 'dddd, MMMM DD, YYYY',
  dateTimeFormat: 'MM/DD/YYYY h:mm a',
  smallTimeFormat: 'h:mm',
  timeFormat: 'h:mm a',
  timeFormatUppercase: 'h:mm A',
  timeFormatFull: 'HH:mm',
  shortDateFormat: 'dddd, h:mm a',
  mediumDateFormat: 'MMM DD, YYYY',
  fullDateTimeFormat: 'dddd, MMMM Do, h:mm a',
  longDateTimeFormat: 'MMMM D, YYYY, h:mma',
  defaultTimezone: 'America/New_York',
  availableHours: {
    start: {
      hours: '5',
      minutes: '0',
      padding: -2,
    },
    end: {
      hours: '23',
      minutes: '55',
      padding: 2,
    },
  },
  defaultWorkHours: {
    start: {
      hours: '9',
      minutes: '0',
    },
    end: {
      hours: '18',
      minutes: '0',
    },
  },
  wholeDay: {
    start: {
      hours: '0',
      minutes: '0',
    },
    end: {
      hours: '23',
      minutes: '59',
    },
  },
  minInterval: 5,
  defaultMinServiceLen: 15,
  defaultMaxAppointmentLen: 8 * 60,
  maxCustomDuration: 12 * 60,
  showedWeeks: {
    from: -4,
    to: 52,
  },
  pubnubSubscribeKey: process.env.PUBNUB_SUB_KEY,
  pubnubPublishKey: process.env.PUBNUB_PUB_KEY,
  typesense: {
    url: (process.env.TYPESENSE_URL || '').split(','),
    indexDocs: `docs_${process.env.TYPESENSE_ENV}`,
    indexShops: `shops_${process.env.TYPESENSE_ENV}`,
    indexUsers: `users_${process.env.TYPESENSE_ENV}`,
    indexBrands: `brands_${process.env.TYPESENSE_ENV}`,
    delimiterRegex: /[@.+\-_,() ]/,
    infixThreshold: 3,
    options: {
      highlight_start_tag: '<em>',
      highlight_end_tag: '</em>',
      per_page: 15,
    },
  },
  instagram: {
    apiUrl: 'https://api.instagram.com',
    clientId: process.env.INSTAGRAM_APP_ID,
    redirectUri: process.env.INSTAGRAM_REDIRECT_URI,
    scopes: 'instagram_business_basic',
  },
  intercomId: process.env.INTERCOM_ID,
  ENTER_KEY_CODE: 13,
  providerMode: process.env.PROVIDER_MODE,
  exportReportDays: 30,
  defaultFeatures: {
    supportsCart: true,
    nonBlockingHandoff: false,
  },
  datadog: {
    clientToken: process.env.PUBLIC_DATADOG_TOKEN,
    appId: process.env.PUBLIC_DATADOG_APP_ID,
    service: process.env.PUBLIC_DATADOG_SERVICE,
    sessionSampleRate: process.env.PUBLIC_DATADOG_SAMPLE_RATE,
    traceSampleRate: process.env.PUBLIC_DATADOG_TRACE_SAMPLE_RATE,
  },
  terminalSimulatedMode: process.env.TERMINAL_SIMULATED_MODE,
  sentry: {
    dsn: process.env.SENTRY_DSN,
    slug: process.env.SENTRY_SLUG,
  },
  analytics: {
    ChurnZero: {
      appKey: process.env.CHURNZERO_APP_KEY,
    },
    Fullstory: {
      orgId: process.env.FULLSTORY_ORG_ID,
    },
    Mixpanel: {
      token: process.env.MIXPANEL_TOKEN,
    },
    PostHog: {
      apiKey: process.env.POSTHOG_API_KEY,
      apiHost: 'https://us.i.posthog.com',
    },
    CustomerIo: {
      writeKey: process.env.CUSTOMER_IO_WRITE_KEY,
      siteId: process.env.CUSTOMER_IO_SITE_ID,
    },
    Rudderstack: {
      dataPlaneUrl: process.env.RUDDERSTACK_DATA_PLANE_URL,
      writeKey: process.env.RUDDERSTACK_WRITE_KEY,
    },
  },
  deploymentEnv: process.env.DEPLOYMENT_ENV,
  importLimit: 50000,
  defaultDuration: 5,
  salesForceChat: {
    url: process.env.SALES_FORCE_CHAT_URL || 'https://d.la5-c2-ia5.salesforceliveagent.com/chat',
    key: process.env.SALES_FORCE_CHAT_KEY || '00D4W000005hp6X',
  },
  salesforceMessagingSessionsChat: {
    key: process.env.SALES_FORCE_MESSAGING_SESSIONS_CHAT_KEY || '00D4W000005hp6X',
    url:
      process.env.SALES_FORCE_MESSAGING_SESSIONS_CHAT_URL ||
      'https://getsquire.my.site.com/ESWCommanderMessagingSe1723044670735',
  },
  salesForceHelp: {
    url: process.env.SALES_FORCE_HELP_URL || 'https://getsquire.my.site.com/help/s/',
  },
  mailchimpClientId: process.env.MAILCHIMP_CLIENT_ID,
  launchDarkly: {
    // Points to the default client side id for test env on launchdarkly when env variable is not set
    clientSideId: process.env.LD_CLIENT_KEY || '6436c833d00d0c1325b6549f',
  },
  commanderAppUrl: {
    apple: 'https://apps.apple.com/app/squire-commander/id1254375220',
    android: 'https://play.google.com/store/apps/details?id=com.getsquire.commander',
  },
};

export default config;
